import { unfold } from "../fable_modules/fable-library.3.7.14/List.js";
import { fold, iterate } from "../fable_modules/fable-library.3.7.14/Seq.js";
import { rangeDouble } from "../fable_modules/fable-library.3.7.14/Range.js";

export function rlewDecode(createDataView, mapHeadView, inView) {
    const rlewTag = mapHeadView.getUint16(0, true);
    const outView = createDataView(~(~inView.getUint16(0, true)));
    unfold((tupledArg) => {
        const inOffset = tupledArg[0] | 0;
        const outOffset = tupledArg[1] | 0;
        let patternInput;
        const w = inView.getUint16(inOffset, true);
        const newInOffset = (inOffset + 2) | 0;
        if (w === rlewTag) {
            const n = inView.getUint16(newInOffset, true);
            const x = inView.getUint16(newInOffset + 2, true);
            iterate((i) => {
                outView.setUint16(outOffset + (i * 2), x, true);
            }, rangeDouble(0, 1, (~(~n)) - 1));
            patternInput = [newInOffset + 4, outOffset + (2 * (~(~n)))];
        }
        else {
            outView.setUint16(outOffset, w, true);
            patternInput = [newInOffset, outOffset + 2];
        }
        const nextInOffset = patternInput[0] | 0;
        return (nextInOffset < inView.byteLength) ? [void 0, [nextInOffset, patternInput[1]]] : (void 0);
    }, [2, 0]);
    return outView;
}

export function carmackDecode(createDataView, inView) {
    const outView = createDataView(~(~inView.getUint16(0, true)));
    const isNearPointer = (possiblePointer) => (possiblePointer === 167);
    unfold((tupledArg) => {
        let possiblePointer_1;
        const inOffset = tupledArg[0] | 0;
        const outOffset = tupledArg[1] | 0;
        let patternInput;
        const x = inView.getUint8(inOffset + 1);
        if ((possiblePointer_1 = x, isNearPointer(possiblePointer_1) ? true : (possiblePointer_1 === 168))) {
            const n = inView.getUint8(inOffset);
            if (n === 0) {
                outView.setUint8(outOffset, inView.getUint8(inOffset + 2));
                outView.setUint8(outOffset + 1, x);
                patternInput = [inOffset + 3, outOffset + 2];
            }
            else if (isNearPointer(x)) {
                const offset = (2 * (~(~inView.getUint8(inOffset + 2)))) | 0;
                patternInput = [inOffset + 3, fold((foldOffset, _arg1) => {
                    outView.setUint16(foldOffset, outView.getUint16(foldOffset - offset, true), true);
                    return (foldOffset + 2) | 0;
                }, outOffset, rangeDouble(0, 1, (~(~n)) - 1))];
            }
            else {
                const offset_1 = (2 * (~(~inView.getUint16(inOffset + 2, true)))) | 0;
                patternInput = [inOffset + 4, fold((foldOffset_1, i) => {
                    outView.setUint16(foldOffset_1, outView.getUint16(offset_1 + (2 * i), true), true);
                    return (foldOffset_1 + 2) | 0;
                }, outOffset, rangeDouble(0, 1, (~(~n)) - 1))];
            }
        }
        else {
            outView.setUint16(outOffset, inView.getUint16(inOffset, true), true);
            patternInput = [inOffset + 2, outOffset + 2];
        }
        const newInOffset = patternInput[0] | 0;
        return (newInOffset >= inView.byteLength) ? (void 0) : [void 0, [newInOffset, patternInput[1]]];
    }, [2, 0]);
    return outView;
}

